import { FunctionComponent } from 'react';

import { avatarElementBase, avatarImage } from './avatarCssDefs';

/**
 * Currently named AvatarElementSize as non-image avatars (down the road) will follow the same guidelines.
 */
export type AvatarElementSize = 'small' | 'medium' | 'large' | 'xlarge';

export interface AvatarImageCoreProps {
  /**
   * Descriptive alt text for the avatar image.
   */
  alt: string;
  /**
   * Size of the avatar image.
   */
  size: AvatarElementSize;
  /**
   * Image src for the avatar image.
   */
  src: string;
}

export const AvatarImageCore: FunctionComponent<AvatarImageCoreProps> = ({
  alt,
  size,
  ...rest // src, children
}) => {
  return <img alt={alt} css={[avatarElementBase(size), avatarImage]} {...rest} />;
};
